import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';


const LoadingProgress = (props) => {

  const useStyles = makeStyles(theme => ({
    progress: {
      margin: theme.spacing(2),
    },
  }));

  useStyles();

  function handleClose() {
    if (props.onChange)
      props.onChange();
  }

  if (!props.open)
    return null;

  return (
    <div >
      <Modal
        style={{zIndex: 1020}}
        open={props.open}
        onClose={handleClose}
        disableBackdropClick={true}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div style={{outline: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '30%'}}>
          <CircularProgress  />
          {props.message
            ?
              <h2 style={{color: "#ff8d3e", margin:"2px 20px", fontSize:20, fontWeight:500, fontFamily:"Ubuntu, sans-serif", fontVariantCaps: "small-caps" }}>{props.message}</h2>
            :
              <></>
          }
        </div>
      </Modal>
    </div>
  );
};

export default LoadingProgress;
